import Swiper from "swiper";
import { Pagination, Navigation, A11y } from "swiper/modules";

const imageSlider = () => {
	new Swiper("#js--image-slider", {
		modules: [Pagination, Navigation, A11y],
		a11y: {
			prevSlideMessage: "Previous slide",
			nextSlideMessage: "Next slide"
		},
		direction: "horizontal",
		loop: false,
		freeMode: false,
		observer: true,
		observeParents: true,
		centeredSlides: false,
		watchOverflow: true,
		navigation: {
			prevEl: ".swiper-button-prev",
			nextEl: ".swiper-button-next",
		},
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
			clickable: true,
		},
		spaceBetween: 0,
		slidesPerView: 1,
	});
};

export default imageSlider;
